<template>
    <validation-observer ref="form" v-slot="{ meta, handleSubmit }">
        <busy-modal :show="loading"></busy-modal>
        <b-form v-if="values" @submit.prevent="handleSubmit(_, update)">
            <div class="mb-4">
                <b-button class="mr-1" type="submit" variant="primary" :disabled="loading || !meta.valid">
                    Publish
                </b-button>
                <b-button variant="secondary" @click="handleResetClick"> Reset </b-button>
            </div>
            <p class="font-weight-bold text-uppercase text-center">Header</p>
            <form-inline-bordered-group>
                <template v-slot:left> Header </template>
                <template v-slot:right>
                    <form-checkbox class="no-margin" v-model="values.display_online_header" @change="updatePreview"
                        >Display</form-checkbox
                    >
                    <form-checkbox class="no-margin" v-model="values.anchored_menu" @change="updatePreview"
                        >Anchored</form-checkbox
                    >
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group right-class="mr-2">
                <template v-slot:left> Header items </template>
                <template v-slot:right>
                    <form-checkbox
                        class="no-margin"
                        v-model="values.css_variables.header_display_title"
                        @change="updatePreviewCss"
                        >Title</form-checkbox
                    >
                    <form-checkbox
                        class="no-margin"
                        v-model="values.css_variables.header_display_address"
                        @change="updatePreviewCss"
                        >Address</form-checkbox
                    >
                    <form-checkbox
                        class="no-margin"
                        v-model="values.css_variables.header_display_return"
                        @change="updatePreviewCss"
                        >Return</form-checkbox
                    >
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left> @header-logo </template>
                <template v-slot:right>
                    <validation-provider name="css_variables.header_logo" v-slot="{ errors }">
                        <form-select
                            class="no-margin"
                            v-model="values.css_variables.header_logo"
                            :full-width="false"
                            :options="headerLogoOptions"
                            :error="errors[0]"
                            @change="updatePreviewCss"
                        ></form-select>
                    </validation-provider>
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group v-if="website.logo_url" right-class="w-100 mt-2">
                <template v-slot:left> @header-logo-image </template>
                <template v-slot:right>
                    <div><img class="img-thumbnail" :src="website.logo_url" /></div>
                    <div>
                        <b-button class="mt-2" variant="outline-danger" @click="handleDeleteLogoClick">
                            Delete
                        </b-button>
                    </div>
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group v-else>
                <template v-slot:left> @header-logo-image </template>
                <template v-slot:right>
                    <form-file
                        class="no-margin"
                        :accept="LODGIX_IMAGE_FILES_ALLOWED_EXTENSIONS.join(',')"
                        placeholder="Upload logo..."
                        v-model="logo"
                    ></form-file>
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left> @header-text-float </template>
                <template v-slot:right>
                    <validation-provider name="css_variables.header_text_float" v-slot="{ errors }">
                        <form-select
                            class="no-margin"
                            v-model="values.css_variables.header_text_float"
                            :full-width="false"
                            :options="headerTextFloatOptions"
                            :error="errors[0]"
                            @change="updatePreviewCss"
                        ></form-select>
                    </validation-provider>
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left> @header-text-align </template>
                <template v-slot:right>
                    <validation-provider name="css_variables.header_text_align" v-slot="{ errors }">
                        <form-select
                            class="no-margin"
                            v-model="values.css_variables.header_text_align"
                            :full-width="false"
                            :options="headerTextAlignOptions"
                            :error="errors[0]"
                            @change="updatePreviewCss"
                        ></form-select>
                    </validation-provider>
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left> @header-background-color </template>
                <template v-slot:right>
                    <validation-provider name="css_variables.header_background_color" v-slot="{ errors }">
                        <form-input
                            class="no-margin color-picker-input"
                            type="color"
                            v-model="values.css_variables.header_background_color"
                            :error="errors[0]"
                            @change="updatePreviewCss"
                        ></form-input>
                    </validation-provider>
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left> @header-border-bottom-color </template>
                <template v-slot:right>
                    <validation-provider name="css_variables.header_border_bottom_color" v-slot="{ errors }">
                        <form-input
                            class="no-margin color-picker-input"
                            type="color"
                            v-model="values.css_variables.header_border_bottom_color"
                            :error="errors[0]"
                            @change="updatePreviewCss"
                        ></form-input>
                    </validation-provider>
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left> @header-title-font </template>
                <template v-slot:right>
                    <validation-provider name="css_variables.header_title_font" v-slot="{ errors }">
                        <form-select
                            class="no-margin"
                            v-model="values.css_variables.header_title_font"
                            :full-width="false"
                            :options="fontOptions"
                            :error="errors[0]"
                            @change="updatePreviewCss"
                        ></form-select>
                    </validation-provider>
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left> @header-font </template>
                <template v-slot:right>
                    <validation-provider name="css_variables.header_font" v-slot="{ errors }">
                        <form-select
                            class="no-margin"
                            v-model="values.css_variables.header_font"
                            :full-width="false"
                            :options="fontOptions"
                            :error="errors[0]"
                            @change="updatePreviewCss"
                        ></form-select>
                    </validation-provider>
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left> @header-font-color </template>
                <template v-slot:right>
                    <validation-provider name="css_variables.header_font_color" v-slot="{ errors }">
                        <form-input
                            class="no-margin color-picker-input"
                            type="color"
                            v-model="values.css_variables.header_font_color"
                            :error="errors[0]"
                            @change="updatePreviewCss"
                        ></form-input>
                    </validation-provider>
                </template>
            </form-inline-bordered-group>
            <p class="font-weight-bold text-uppercase text-center mt-title">Body</p>
            <form-inline-bordered-group>
                <template v-slot:left> @primary-background-color </template>
                <template v-slot:right>
                    <validation-provider name="css_variables.primary_background_color" v-slot="{ errors }">
                        <form-input
                            class="no-margin color-picker-input"
                            type="color"
                            v-model="values.css_variables.primary_background_color"
                            :error="errors[0]"
                            @change="updatePreviewCss"
                        ></form-input>
                    </validation-provider>
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left> @body-background-color </template>
                <template v-slot:right>
                    <validation-provider name="css_variables.body_background_color" v-slot="{ errors }">
                        <form-input
                            class="no-margin color-picker-input"
                            type="color"
                            v-model="values.css_variables.body_background_color"
                            :error="errors[0]"
                            @change="updatePreviewCss"
                        ></form-input>
                    </validation-provider>
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left> @body-title-font </template>
                <template v-slot:right>
                    <validation-provider name="css_variables.body_title_font" v-slot="{ errors }">
                        <form-select
                            class="no-margin"
                            v-model="values.css_variables.body_title_font"
                            :full-width="false"
                            :options="fontOptions"
                            :error="errors[0]"
                            @change="updatePreviewCss"
                        ></form-select>
                    </validation-provider>
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left> @body-title-color </template>
                <template v-slot:right>
                    <validation-provider name="css_variables.body_title_color" v-slot="{ errors }">
                        <form-input
                            class="no-margin color-picker-input"
                            type="color"
                            v-model="values.css_variables.body_title_color"
                            :error="errors[0]"
                            @change="updatePreviewCss"
                        ></form-input>
                    </validation-provider>
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left> @body-font </template>
                <template v-slot:right>
                    <validation-provider name="css_variables.body_font" v-slot="{ errors }">
                        <form-select
                            class="no-margin"
                            v-model="values.css_variables.body_font"
                            :full-width="false"
                            :options="fontOptions"
                            :error="errors[0]"
                            @change="updatePreviewCss"
                        ></form-select>
                    </validation-provider>
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left> @body-font-color </template>
                <template v-slot:right>
                    <validation-provider name="css_variables.body_font_color" v-slot="{ errors }">
                        <form-input
                            class="no-margin color-picker-input"
                            type="color"
                            v-model="values.css_variables.body_font_color"
                            :error="errors[0]"
                            @change="updatePreviewCss"
                        ></form-input>
                    </validation-provider>
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left> @body-warning-color </template>
                <template v-slot:right>
                    <validation-provider name="css_variables.body_warning_color" v-slot="{ errors }">
                        <form-input
                            class="no-margin color-picker-input"
                            type="color"
                            v-model="values.css_variables.body_warning_color"
                            :error="errors[0]"
                            @change="updatePreviewCss"
                        ></form-input>
                    </validation-provider>
                </template>
            </form-inline-bordered-group>
            <p class="font-weight-bold text-uppercase text-center mt-title">Settings</p>
            <form-inline-bordered-group>
                <template v-slot:left>
                    <form-checkbox class="no-margin" v-model="values.allow_guest_quotes"
                        >Allow Guest Quote Sharing?</form-checkbox
                    >
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left>
                    <form-checkbox class="no-margin" v-model="values.display_coupon_code" @change="updatePreview"
                        >Allow Coupon Codes?</form-checkbox
                    >
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left>
                    <form-checkbox class="no-margin" v-model="values.is_message_field_required" @change="updatePreview"
                        >Require Message Field?</form-checkbox
                    >
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left>
                    <form-checkbox
                        v-if="values.staylio_enabled"
                        class="no-margin"
                        v-model="values.display_staylio_guest_app"
                        >Market guest app availability during the online booking process? (direct bookings
                        only).</form-checkbox
                    >
                    <form-checkbox v-else disabled class="no-margin" value="false"
                        >Market Staylio app availability during the online booking process? (direct bookings only).
                        Staylio app access must be enabled first.</form-checkbox
                    >
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left>
                    <form-checkbox
                        class="no-margin"
                        v-model="values.is_rental_agreement_scrollable"
                        @change="updatePreview"
                        >Scrollable Rental Agreement?</form-checkbox
                    >
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group v-if="values.is_rental_agreement_scrollable">
                <template v-slot:left>
                    <span>Rental Agreement Field Height</span>
                </template>
                <template v-slot:right>
                    <form-select
                        class="no-margin"
                        v-model="values.rental_agreement_content_height"
                        @change="updatePreview"
                        :options="rentalAgreementHeightOptions"
                    />
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left>
                    <span>How Many Property Photos?</span>
                </template>
                <template v-slot:right>
                    <form-select
                        class="no-margin"
                        v-model="values.gallery_image_number"
                        @change="updatePreview"
                        :options="galleryImageNumberOptions"
                    />
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left>
                    <span>Message Field Label</span>
                </template>
                <template v-slot:right>
                    <validation-provider name="message_field_label" v-slot="{ errors }">
                        <form-input
                            class="no-margin"
                            v-model="values.message_field_label"
                            :placeholder="website.message_field_label_placeholder"
                            :error="errors[0]"
                            @input="updatePreviewDebounced"
                        ></form-input>
                    </validation-provider>
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left>
                    <span>Booking Page URL</span>
                </template>
                <template v-slot:right>
                    <a :href="website.full_url" target="blank_">{{ website.full_url }}</a>
                </template>
            </form-inline-bordered-group>
            <div class="mt-4 mb-4">
                <b-button type="submit" class="mr-1" variant="primary" :disabled="loading || !meta.valid">
                    Publish
                </b-button>
                <b-button variant="secondary" @click="handleResetClick"> Reset </b-button>
            </div>
        </b-form>
        <modal :id="resetModalID" title="Reset" @ok="reset"
            >Are you sure you want to reset all CSS settings? All changes will be lost.</modal
        >
        <modal :id="deleteLogoModalID" title="Delete Logo" @ok="deleteLogo"
            >Are you sure you want to delete the logo? This will affect emails and PDFs as well.</modal
        >
    </validation-observer>
</template>

<script>
    import debounce from 'lodash/debounce';
    import isEmpty from 'lodash/isEmpty';
    import range from 'lodash/range';
    import { formatResponseError } from '../../../utils/api';
    import BusyModal from '../../generic/busy-modal/busy-modal.vue';
    import FormCheckbox from '../../generic/form-checkbox/form-checkbox.vue';
    import FormFile from '../../generic/form-file/form-file.vue';
    import FormInlineBorderedGroup from '../../generic/form-inline-bordered-group/form-inline-bordered-group.vue';
    import FormInput from '../../generic/form-input/form-input.vue';
    import FormSelect from '../../generic/form-select/form-select.vue';
    import FormTextarea from '../../generic/form-textarea/form-textarea.vue';
    import Modal from '../../generic/modal/modal.vue';
    import { LODGIX_IMAGE_FILES_ALLOWED_EXTENSIONS } from '../../../constants';

    export default {
        name: 'WebsiteEditorForm',
        components: {
            BusyModal,
            FormCheckbox,
            FormFile,
            FormInlineBorderedGroup,
            FormInput,
            FormSelect,
            FormTextarea,
            Modal,
        },
        props: {
            website: Object,
        },
        computed: {
            values: {
                get() {
                    return this.$store.getters['website/websiteFormValues'];
                },
                set(values) {
                    this.$store.commit('website/setWebsiteFormValues', values);
                },
            },
            galleryImageNumberOptions() {
                return range(2, 6).map((i) => ({
                    value: i,
                    text: i,
                }));
            },
            rentalAgreementHeightOptions() {
                return [{ value: null, text: 'Auto' }].concat(
                    range(300, 900, 50).map((i) => ({ value: i, text: `${i}px` }))
                );
            },
            headerLogoOptions() {
                return [
                    { value: 'left', text: 'Float Left' },
                    { value: 'right', text: 'Float Right' },
                    { value: 'none', text: 'Float None' },
                    { value: '', text: 'Hide' },
                ];
            },
            headerTextFloatOptions() {
                return [
                    { value: 'left', text: 'Left' },
                    { value: 'right', text: 'Right' },
                    { value: 'none', text: 'None' },
                ];
            },
            headerTextAlignOptions() {
                return [
                    { value: 'left', text: 'Left' },
                    { value: 'right', text: 'Right' },
                    { value: 'center', text: 'Center' },
                ];
            },
            fontOptions() {
                return [
                    { value: 'Arial, verdana, sans-serif', text: 'Arial' },
                    { value: 'Arial Black, Gadget, sans-serif', text: 'Arial Black' },
                    { value: 'Georgia, serif', text: 'Georgia' },
                    { value: 'Impact, Charcoal, sans-serif', text: 'Impact' },
                    { value: 'Lucida Sans Unicode, Lucida Grande, sans-serif', text: 'Lucida' },
                    { value: 'Palatino Linotype, Book Antiqua, Palatino, serif', text: 'Palatino' },
                    { value: 'Times New Roman, Times, serif', text: 'Times New Roman' },
                    { value: 'Trebuchet MS, Helvetica, sans-serif', text: 'Trebuchet' },
                    { value: 'Verdana, Geneva, sans-serif', text: 'Verdana' },
                ];
            },
        },
        data() {
            return {
                loading: false,
                resetModalID: 'reset-current-website-modal',
                deleteLogoModalID: 'delete-logo-current-website-modal',
                logo: null,
                LODGIX_IMAGE_FILES_ALLOWED_EXTENSIONS,
            };
        },
        mounted() {
            this.values = this.getInitialValues();
        },
        methods: {
            getInitialValues() {
                return {
                    anchored_menu: this.website.anchored_menu || false,
                    display_online_header: this.website.display_online_header || false,
                    display_coupon_code: this.website.display_coupon_code || false,
                    allow_guest_quotes: this.website.allow_guest_quotes || false,
                    display_staylio_guest_app: this.website.display_staylio_guest_app || false,
                    staylio_enabled: this.website.staylio_enabled || false,
                    is_message_field_required: this.website.is_message_field_required || false,
                    is_rental_agreement_scrollable: this.website.is_rental_agreement_scrollable || false,
                    rental_agreement_content_height: this.website.rental_agreement_content_height || null,
                    message_field_label: this.website.message_field_label || '',
                    gallery_image_number: this.website.gallery_image_number || false,
                    css_variables: {
                        header_logo: this.website.css_variables.header_logo,
                        header_display_title: this.website.css_variables.header_display_title || false,
                        header_display_address: this.website.css_variables.header_display_address || false,
                        header_display_return: this.website.css_variables.header_display_return || false,
                        header_text_align: this.website.css_variables.header_text_align || 'left',
                        header_text_float: this.website.css_variables.header_text_float || 'none',
                        header_background_color: this.website.css_variables.header_background_color || null,
                        header_border_bottom_color: this.website.css_variables.header_border_bottom_color || null,
                        header_title_font: this.website.css_variables.header_title_font || null,
                        header_font: this.website.css_variables.header_font || null,
                        header_font_color: this.website.css_variables.header_font_color || null,
                        primary_background_color: this.website.css_variables.primary_background_color || null,
                        body_background_color: this.website.css_variables.body_background_color || null,
                        body_title_font: this.website.css_variables.body_title_font || null,
                        body_title_color: this.website.css_variables.body_title_color || null,
                        body_font: this.website.css_variables.body_font || null,
                        body_font_color: this.website.css_variables.body_font_color || null,
                        body_warning_color: this.website.css_variables.body_warning_color || null,
                    },
                };
            },
            async update() {
                this.loading = true;

                try {
                    await this.$store.dispatch('website/updateCurrentWebsite', this.values);
                    this.successToast({
                        text: 'Published successfully. Refreshing...',
                    });
                } catch (err) {
                    const { generic, fields } = formatResponseError(err);

                    if (generic) {
                        this.errorToast({ text: generic });
                    }
                    if (!isEmpty(fields)) {
                        this.$refs.form.setErrors(fields);
                    }
                } finally {
                    this.loading = false;
                }
            },
            async reset() {
                this.loading = true;

                try {
                    await this.$store.dispatch('website/resetCurrentWebsite');
                    this.successToast({
                        text: 'Reset successfully. Refreshing...',
                    });
                    this.$emit('reset');
                } catch (err) {
                    const { generic } = formatResponseError(err);

                    this.errorToast({ text: generic || 'Could not reset the website.' });
                } finally {
                    this.loading = false;
                }
            },
            async uploadLogo() {
                this.loading = true;

                try {
                    await this.$store.dispatch('website/uploadLogoForCurrentWebsite', { logo: this.logo });
                    this.successToast({
                        text: 'Logo uploaded successfully. Refreshing...',
                    });
                    this.$emit('logo-upload');
                } catch (err) {
                    const { generic, fields } = formatResponseError(err);

                    this.errorToast({ text: generic || 'Could not upload logo.' });
                } finally {
                    this.loading = false;
                }
            },
            async deleteLogo() {
                this.loading = true;

                try {
                    await this.$store.dispatch('website/deleteLogoForCurrentWebsite');
                    this.successToast({
                        text: 'Logo deleted successfully. Refreshing...',
                    });
                    this.logo = null;
                    this.$emit('logo-delete');
                } catch (err) {
                    const { generic, fields } = formatResponseError(err);

                    this.errorToast({ text: generic || 'Could not delete logo.' });
                } finally {
                    this.loading = false;
                }
            },
            async updatePreviewRequest({ css = false } = {}) {
                await this.$nextTick();

                this.loading = true;

                try {
                    await this.$store.dispatch('website/updatePreview', this.values);
                    this.$emit(css ? 'preview-update-css' : 'preview-update');
                } catch (err) {
                    const { generic, fields } = formatResponseError(err);

                    if (generic) {
                        this.errorToast({ text: generic });
                    }
                    if (!isEmpty(fields)) {
                        this.$refs.form.setErrors(fields);
                    }
                } finally {
                    this.loading = false;
                }
            },
            updatePreviewCss() {
                return this.updatePreviewRequest({ css: true });
            },
            updatePreview() {
                return this.updatePreviewRequest();
            },
            updatePreviewDebounced: debounce(function () {
                return this.updatePreview();
            }, 1000),
            handleResetClick() {
                this.$bvModal.show(this.resetModalID);
            },
            handleDeleteLogoClick() {
                this.$bvModal.show(this.deleteLogoModalID);
            },
        },
        watch: {
            logo() {
                if (this.logo) {
                    this.uploadLogo();
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .mt-title {
        margin-top: 5rem;
    }

    .no-margin {
        margin: 0rem !important;
    }

    .color-picker-input {
        width: 5rem;
    }
</style>
